import React from "react";
import "./searchList.scss";

const FeatureresSearchList = ({ features, onSelectFeatureHandler, style }) => {
    return (
        <div className="searchList" style={style || { width: "60%" }}>
            <div className="searchList__scroll">
                <ul className="list-group">
                    {features.map((feature) => {
                        return (
                            <li
                                className="list-group-item custom-list-item"
                                key={feature.id}
                                onClick={() => onSelectFeatureHandler(feature)}
                            >
                                {feature.title}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default FeatureresSearchList;
